import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/core/styles';

import { RiFileTextLine } from '@remixicon/react';

import { DocAttachment, attachmentKey } from '../../types';

const useStyles = makeStyles(theme => ({
  chip: {
    maxWidth: theme.spacing(30),
    height: 'var(--encore-spacing-looser)',
    fontSize: 'var(--encore-text-size-smaller-2)',
    backgroundColor: 'var(--background-elevated-base)',
    color: 'var(--text-base)',
  },
  icon: {
    marginLeft: theme.spacing(0.75),
    flexShrink: 0,
  },
}));

interface AttachmentChipProps {
  attachment: DocAttachment;
  onRemove?: (key: string) => void;
  onClick?: (attachment: DocAttachment) => void;
}

export const AttachmentChip = ({
  attachment,
  onRemove,
  onClick,
}: AttachmentChipProps) => {
  const classes = useStyles();
  const handleClick = () => {
    if (onClick) {
      onClick(attachment);
      return;
    }
    if (attachment.uri) {
      window.open(attachment.uri, '_blank', 'noopener,noreferrer');
    }
  };
  return (
    <Chip
      className={classes.chip}
      size="small"
      label={attachment.title}
      icon={<RiFileTextLine size={14} className={classes.icon} />}
      onClick={attachment.uri || onClick ? handleClick : undefined}
      onDelete={
        onRemove ? () => onRemove(attachmentKey(attachment)) : undefined
      }
    />
  );
};
